module.exports = __webpack_public_path__ + "img/publicis.1d10fe48.png";